module.exports = function() {
  return new Worker(__webpack_public_path__ + "c7fda2049e417f06b352.worker.js");
};